import React from 'react'

import { config } from '../../../../../common/config'
import styles from './trendingSash.module.css'

const srcUrl = `${config.assets.PUBLIC_PATH}/images/trending-sash.svg`

export const TrendingItem = () => {
  return <img className={styles.trending} alt="Trending" src={srcUrl} />
}

export default TrendingItem
